import {getDispatch} from '../../stores/configure-store';
import {getCookie} from "../../lib/cookieHelper";
import {ALERT_VARIANT, COOKIE_AUTHTOKEN, EResponseCode} from "../../const/dataEnum";
import {sessionExpired} from "../../stores/business/appBusiness";
import Axios from 'axios';
import {setAlert} from '../../stores/actions/alertModalStateAction';

const getCustomAxios = () => {
  const customAxios = Axios.create({});
  const dispatch = getDispatch();

  customAxios.interceptors.request.use(
    (reqConfig) => {
      if (!reqConfig.headers.Authorization) {
        const token = getCookie(COOKIE_AUTHTOKEN);
        if (token) {
          reqConfig.headers.Authorization = `Bearer ${token}`;
        }
      }
      return reqConfig;
    },
    (error) => Promise.reject(error),
  );

  customAxios.interceptors.response.use(
    (response) => {
      if (response.data.responseCode !== undefined) {
        if (
          response.data.responseCode !== EResponseCode.NO_ERROR &&
          response.data.responseCode !== EResponseCode.ITEM_NOT_FOUND
        ) {
          dispatch(
            setAlert({
              show: true,
              variant: ALERT_VARIANT.ERROR,
              message: response.data.message,
            })
          );
        }
      }
      return response
    },
    async (error) => {
      const status = error?.response?.status;
      if ((status === 403 || status === 401)) {
        dispatch(sessionExpired());
      } else {
        dispatch(
          setAlert({
            show: true,
            variant: ALERT_VARIANT.ERROR,
            message: error.message,
          })
        );
      }
      return Promise.reject(error);
    },
  );
  return customAxios;
};

export const callAPI = async ({
    _async = true,
    _timeout = 2700000, //set timeout to 45 minutes
    method,
    url,
    data,
    params,
    responseType,
    onUploadProgress,
    headers
  }) => {
  let axios = getCustomAxios();
  let response;
  axios.defaults.timeout = _timeout;
  try {
    const _param = {
      method,
      url,
      data,
      params,
      responseType,
      onUploadProgress,
      headers,
    };
    response = _async ? await axios({..._param}) : axios({..._param});
  } catch (err) {
    throw err;
  }
  return response;
};